export default __webpack_public_path__ + "static/media/fvwDUbWB.16320b24.svg";